import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// Providers
import { NotificationsProvider } from '@/lib/notifications'
import { WeighbridgeProvider } from '@/lib/WeighbridgePoller'

// remember shape choice
const shape = localStorage.getItem('ui:shape') || 'square'
document.documentElement.setAttribute('data-shape', shape)

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <NotificationsProvider>
        <WeighbridgeProvider>
          <App />
        </WeighbridgeProvider>
      </NotificationsProvider>
    </BrowserRouter>
  </React.StrictMode>
)
